import Enum from "./Enum";

export default Enum.create( {
	COMMENT: "COMMENT",
	CONFIDENCE: "CONFIDENCE",
	CREATE: "CREATE",
	NAME: "NAME",
	OWNER: "OWNER",
	PROGRESS: "PROGRESS",
	SORT_ORDER: "SORT_ORDER",
	TYPE: "TYPE",
} );
